<template>
  <h1 class="h1"
    :class="{'no-underline': noUnderline}">
    <slot></slot>
  </h1>
</template>

<script>
export default {
  name: 'AfH1',
  props: {
    noUnderline: Boolean
  }
}
</script>

<style lang="postcss" scoped>
@import '../variables/custom-media.css';
.h1 {
  font-size: 28px;
  font-weight: 600;
  color: #000000;
  line-height: 35px;
  margin-bottom: 0;
  margin-top: 0;
  
  @media (--bp-nis-medium) {
    font-size: 40px;
    line-height: 50px;
  }

  &:after {
    background-color: var(--color-astral);
    content: '';
    display: block;
    height: 7px;
    margin-top: var(--spacing);
    margin-bottom: var(--spacing-medium);
    width: 115px;

    @media (--bp-nis-medium) {
      height: 10px;
      margin-bottom: var(--spacing-large);
      width: 230px;
    }
  }
}

.no-underline {
  &:after {
    content: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AfH1.vue